import React, { Component } from 'react';
import { provideHooks } from 'redial';
import PropTypes from 'prop-types';
import reducer, * as cardActions from 'redux_store/modules/tenderCard';
import Card from 'components/TenderCard/index';
import * as dictActions from 'redux_store/modules/dictionary/dictionary';
import promises from './dispatchShape';

@provideHooks({
  inject: ({ store }) => {
    store.inject({ tenderCard: reducer });
  },
  fetch: async ({ store: { dispatch, inject, getState }, params }) => {
    const state = getState();
    const { zoneId } = state.login;
    await dispatch(cardActions.getHistory(params.tenderId)).catch(() => null);
    return Promise.all([
      ...promises(inject, dispatch, zoneId, params.tenderId, state),
      dispatch(cardActions.getHistory(params.tenderId)).catch(() => null),
      !dictActions.isLogTypeLoaded(state) ? dispatch(dictActions.loadLogType()).catch(() => null) : Promise.resolve(),
    ]);
  },
})
export default class TenderCardHistory extends Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    match: PropTypes.objectOf(PropTypes.any).isRequired,
  };
  render() {
    const { tenderId } = this.props.match.params;
    return <Card tenderId={tenderId} />;
  }
}
